export enum ExpertTypeEnum {
  Expert = 0,
  AgencyOrCollective = 1,
  Mentors = 2,
}

export const ExpertTypeEnumLabel = {
  [ExpertTypeEnum.Expert]: 'Expert',
  [ExpertTypeEnum.AgencyOrCollective]: 'Agency or Collective',
  [ExpertTypeEnum.Mentors]: 'Mentors',
};
